import { useNavigate, useParams } from "@tanstack/react-router";
import { MessagesSquare } from "lucide-react";
import { EmptyState } from "@dfws/ui";
import { useSession } from "../../lib/queries";
import { useMediaQuery } from "../../app/useMediaQuery";
import { ChannelList } from "./ChannelList";
import { Conversation } from "./Conversation";
import s from "./Chat.module.css";

/** Full chat: conversations on the left, the open one on the right. Phones show one or the other. */
export function ChatView() {
  const params = useParams({ strict: false }) as { channelId?: string };
  const navigate = useNavigate();
  const me = (useSession().data?.user.email ?? "").toLowerCase();
  const isPhone = useMediaQuery("(max-width: 899px)");
  const active = params.channelId;
  const open = (id: string) => void navigate({ to: "/chat/$channelId", params: { channelId: id } });

  return (
    <div className={s.view} data-has-active={active ? "" : undefined}>
      {(!isPhone || !active) && (
        <div className={s.viewList}>
          <h1 className={s.viewTitle}>Chat</h1>
          <ChannelList me={me} activeId={active} onOpen={open} />
        </div>
      )}
      {active ? (
        <Conversation key={active} channelId={active} me={me} variant="full" onClose={isPhone ? () => void navigate({ to: "/chat" }) : undefined} />
      ) : (
        !isPhone && (
          <div className={s.viewEmpty}>
            <EmptyState icon={<MessagesSquare />} title="Pick a conversation">
              Message anyone at your organisation, or start a group. People are online when they have Workspace open.
            </EmptyState>
          </div>
        )
      )}
    </div>
  );
}
